var _excluded = ["items", "className", "variant"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { cva } from 'class-variance-authority';
import React from 'react';
import { cn } from "../lib/utils";
import { TabsContent, Tabs as TabsCore, TabsList, TabsTrigger } from "./tabs";
var tabsVariants = cva('flex-1 py-[8px] px-[14px] h-full rounded-none data-[state=active]:bg-primary-50 data-[state=active]:text-primary-900 text-md', {
  variants: {
    variant: {
      default: '',
      underline: 'border-b-2 border-gray-200 data-[state=active]:border-primary-700'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
var tabsListVariants = cva('rounded-none p-0 overflow-hidden text-gray-500 text-md', {
  variants: {
    variant: {
      default: 'bg-gray-50 divide-x divide-gray-100',
      underline: 'bg-white'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
export var Tabs = function Tabs(props) {
  var _items$;
  var items = props.items,
    className = props.className,
    variant = props.variant,
    others = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(TabsCore, _extends({
    defaultValue: (_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.value
  }, others), /*#__PURE__*/React.createElement(TabsList, {
    className: cn(tabsListVariants({
      variant: variant
    }), className)
  }, items === null || items === void 0 ? void 0 : items.map(function (item) {
    return /*#__PURE__*/React.createElement(TabsTrigger, {
      key: item.value,
      value: item.value,
      className: cn(tabsVariants({
        variant: variant
      }))
    }, item.label);
  })), items === null || items === void 0 ? void 0 : items.map(function (item) {
    return /*#__PURE__*/React.createElement(TabsContent, {
      key: item.value,
      value: item.value
    }, item.content);
  }));
};
export { TabsContent, TabsCore, TabsList, TabsTrigger };